import BigNumber from "bignumber.js";

export const UNIT = new BigNumber(10).pow(18);

declare module "bignumber.js" {
  interface BigNumber {
    truncate(decimalPlaces: number): BigNumber;
    round(decimalPlaces: number): BigNumber;
    floor(decimalPlaces: number): BigNumber;

    toDecimal(): BigNumber;
    fromDecimal(): BigNumber;
    decimalDiv(n: BigNumber): BigNumber;
    decimalMul(n: BigNumber): BigNumber;
    decimalDivRound(n: BigNumber): BigNumber;
    multiplyDecimalRound(n: BigNumber): BigNumber;

    divEvm(n: BigNumber | number): BigNumber;
  }
}

BigNumber.prototype.truncate = function (decimalPlaces: number) {
  return new BigNumber(this.toFixed(decimalPlaces, BigNumber.ROUND_DOWN));
};

BigNumber.prototype.floor = function (decimalPlaces: number) {
  return new BigNumber(this.toFixed(decimalPlaces, BigNumber.ROUND_FLOOR));
};

BigNumber.prototype.round = function (decimalPlaces: number) {
  return new BigNumber(this.toFixed(decimalPlaces));
};

BigNumber.prototype.toDecimal = function () {
  return this.times(UNIT).truncate(0);
};

BigNumber.prototype.fromDecimal = function () {
  return this.div(UNIT);
};

BigNumber.prototype.decimalDiv = function (n: BigNumber) {
  return this.times(UNIT).divEvm(n);
};

BigNumber.prototype.decimalMul = function (n: BigNumber) {
  return this.times(n).divEvm(UNIT);
};

BigNumber.prototype.decimalDivRound = function (n: BigNumber) {
  const r = this.times(UNIT).times(10).divEvm(n);
  if (r.mod(10).gte(5)) {
    r.plus(10);
  }
  return r.divEvm(10);
};

BigNumber.prototype.multiplyDecimalRound = function (n: BigNumber) {
  return this.times(n).div(UNIT).round(0);
};

BigNumber.prototype.divEvm = function (n: BigNumber | number) {
  return this.div(n).truncate(0);
};
